import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../atoms';

export const SCUIGeneralModalFooter = (props: any) => {
    const { t } = useTranslation();

    return (
        <Grid container gap={2} justifyContent="center" sx={{ paddingTop: '1rem', paddingBottom: '2rem' }}>
            <Grid
                container
                justifyContent="flex-end"
                size={{
                    xs: 12,
                    md: 12,
                    lg: 5,
                    xl: 5,
                }}
            >
                <SCUIButton
                    text={t('general.cancel')}
                    type="secondary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={props.onclose}
                />
            </Grid>
            <Grid
                container
                justifyContent="flex-start"
                size={{
                    xs: 12,
                    md: 12,
                    lg: 5,
                    xl: 5,
                }}
            >
                <SCUIButton
                    autoFocusButton={props.autoFocusButton}
                    text={props.buttonText}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={props.functionButtonOnClick}
                    disabled={props.disabled}
                />
            </Grid>
        </Grid>
    );
};
